import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Customer, WorkExperience } from '../../../core/api/models';
import 'react-widgets/dist/css/react-widgets.css';
import WorkExperienceForm from './WorkExperienceForm';
import api from '../../../api';
import { State } from '../../../core/store/interfaces';
import { useLead } from '../../../core';

const Experience: React.FunctionComponent<{
  updateUser?: (details: Customer) => void;
  updated?: () => void;
}> = (props) => {
  const leadState = useSelector((state: State) => state.lead);
  const [isShowForm, setShowForm] = useState<boolean>(true);
  const { updateWorkExperiences, resetWorkExperiences } = useLead(api.lead);

  const onReset = async () => {
    resetWorkExperiences(leadState.leadDetails?.customer?._id, () => {
      toastr.success('Success', 'Work Experiences reset successfully');
      props.updated?.();
    });
  };

  const onSubmit = async (data: WorkExperience) => {
    const workDetails: WorkExperience = {
      jobTitle: data.jobTitle,
      employmentType: data.employmentType,
      companyName: data.companyName,
      businessType: data.businessType,
      location: data.location,
      isCurrentEmployer: data.isCurrentEmployer,
      startDate: data.startDate,
      companyPosition: data.companyPosition,
    };
    if (!data.isCurrentEmployer) {
      workDetails.endDate = data.endDate;
    }

    const updateData: Customer = {
      workDetails: [workDetails],
    };

    updateWorkExperiences(
      updateData,
      leadState.leadDetails?.customer?._id,
      () => {
        toastr.success('Success', 'Work Experiences saved successfully');
        props.updated?.();
      }
    );
  };

  return (
    <div className="p-4 accordion__body border-bottom">
      {isShowForm ? (
        <WorkExperienceForm
          onSubmit={(data) => onSubmit(data)}
          onReset={() => onReset()}
          leadDetails={leadState.leadDetails}
        ></WorkExperienceForm>
      ) : (
        <button
          onClick={() => setShowForm(true)}
          className="btn btn-link font-sm p-0 font-weight-semibold mb-3 mt-1"
        >
          + add Work Experience
        </button>
      )}
    </div>
  );
};

export default Experience;
